<template>
    <ul class="tabs-control">
        <template v-for="(item, i) in list" :key="i">
            <li class="tabs-control__item"
                :class="[modelValue == item[field_value] && 'tabs-control-item--active', item?.icon && 'tabs-control__with-icon', item?.hasError && 'tabs-control__item_error']"
                @click.stop="!disabled ? ($emit('update:modelValue', updateValue(item[field_value]))) : false"
            >
                <slot name="before-name" :item="item"></slot>
                <div class="tabs-control__icon-wrap" v-if="item?.icon">
                    <SvgIcon :name="item?.icon" class="icon"/>
                </div>
                <div v-if="!item?.textHide">
                    {{ item[field_id] }}
                </div>
                <slot name="commands" :item="item"></slot>
            </li>
        </template>
    </ul>
</template>

<script>
import SvgIcon from "@/components/_base/SvgIcon";
export default {
    name: "TabsControl",
    components: {SvgIcon},
    emits:['update:modelValue'],
    props:{
        modelValue: [String, Boolean],
        list:{
            type: [Array, Object],
            default: () => []
        },
        field_id: {
            type: String,
            default: () => 'name'
        },
        field_value: {
            type: String,
            default: () => 'value'
        },
        disabled: {
            type: Boolean,
            default: () => false
        },
        toggleConcept: {
            type: Boolean,
            default: () => false
        }
    },
    methods: {
        updateValue(vl) {
            if(this.toggleConcept && this.modelValue == vl) vl = ''
            return vl;
        }
    }
}
</script>

<style lang="scss" scoped>
.tabs-control{
    display: flex;
    align-items: center;

    &__item{
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        padding: 10px;
        border-bottom: solid 1px var(--border-color);
        @include font(12px, normal, 500, none, normal, var(--color-default));
        cursor: pointer;
        &:not(:first-child):after{
            content: '';
            display: block;
            width: 1px;
            height: 50%;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            background: var(--border-color);
        }

        &.tabs-control-item--active {
            font-weight: 700;
            color: var(--color-default);
            &:before{
                content: '';
                display: block;
                width: 100%;
                height: 3px;
                background: var(--Selected-Element);
                position: absolute;
                left: 0;
                bottom: -1px;
            }
        }

        &_error {
            background: rgba(var(--color-danger-rgb), .15);
        }
    }

    &__with-icon {
        flex-direction: column;
        gap: 5px;
        white-space: nowrap;
        border: none;
        &:not(:first-child):after {
            content: none;
        }
        &.tabs-control-item--active {
            position: relative;
            color: var(--tabs-active-color-with-icon);
            z-index: 2;
            &:before {
                width: 100%;
                height: 100%;
                opacity: var(--tabs-activebg-opasity-with-icon);
                background: var(--tabs-activebg-with-icon);
                box-shadow: var(--tabs-active-box-shadow-with-icon);
                border-radius: 8px;
                z-index: -1;
            }
        }
    }
}
.tabs-control-row {
    background: var(--header-tabs-control-bg);
    box-shadow: var(--route-tabs-list-box-shadow);
    border-radius: 8px;
    display: flex;
    padding: 0 25px;

    .tabs-control__item {
        text-wrap: nowrap;
        border-bottom: solid 1px transparent;
        @include font(16px, normal, 500, none, normal, var(--header-tabs-control-color));
    }
    .tabs-control__item.tabs-control-item--active {
        @include font(16px, normal, 700, none, normal, var(--header-tabs-control-color--active));
    }
    .tabs-control__item:not(:first-child):after {
        display: none;
    }
    .tabs-control__with-icon {
        display: flex;
        align-items: center;
        flex-direction: row;

        &.tabs-control-item--active {
            font-weight: 700;
            color: var(--color-default);
            &:before{
                content: '';
                display: block;
                width: 100%;
                height: 3px;
                background: var(--Selected-Element);
                position: absolute;
                left: 0;
                bottom: -1px;
            }
        }
    }
}
.tabs-wizard {
    .tabs-control {
        &__icon-wrap {
            width: 50px;
            height: 50px;
            border-radius: 100%;
            background: #EAEEF9;
            display: flex;
            justify-content: center;
            align-items: center;
            color: var(--Base-Dark-Blue-2);
        }
        &__item {
            display: flex;
            flex-direction: column;
            color: var(--Base-Dark-Blue-2);
            font-size: 14px;
            //font-weight: 500;
            position: relative;
            z-index: 1;

            &::before{
                content: '';
                width: 100%;
                height: 2px;
                background: #EAEEF9;
                position: absolute;
                top: 35px;
                transform: translateY(-50%);
                left: 0;
                z-index: -1;
            }

            &:first-child:before {
                width: 50%;
                left: auto;
                right: 0;
            }

            &:last-child:before {
                width: 50%;
                left: 0;
            }
        }
    }
    .tabs-control-item--active {
        .tabs-control__icon-wrap {
            background: var(--Blue-Accent-Color);
            color: var(--Blue-Accent-Color);
            .icon {
                color: var(--White-Color);
            }
        }
    }
}
.shipment-tabs {
    width: 100%;
    .tabs-control {
        $this: &;
        &__icon-wrap {
            background: white;
            width: 60px;
            height: 60px;
            padding: 10px;
            border-radius: 8px;
            position: relative;
            &:before {
                content: '';
                display: block;
                width: 100%;
                height: 100%;
                background: #F9FBFF;
                position: absolute;
                left: 0;
                top: 0;
                border-radius: 8px;
                opacity: .7;
                z-index: 1;
            }
            .icon {
                width: 100%;
                height: 100%;
            }
        }

        &__item {
            &.tabs-control-item--active {
                @include font(12px, normal, 700, none, normal, var(--color-default));
                &:before {
                    content: none;
                }
                .tabs-control__icon-wrap {
                    box-shadow: 0px 2px 4px 0px rgba(69, 122, 180, 0.20);
                    &:before {
                        content: none;
                    }
                }
            }
        }

    }
}
.shipment-tabs-50 {
    .tabs-control{
        &__icon-wrap {
            width: 50px;
            height: 50px;
        }
    }
}
</style>